export const convertChirpValueToJson = chirpValue => {
  if (!chirpValue || typeof chirpValue !== 'object') return chirpValue;
  if (chirpValue['@type']) {
    return convertChirpValueToJson(chirpValue.value);
  }
  if (Array.isArray(chirpValue)) {
    return chirpValue.map(convertChirpValueToJson);
  }
  const jsonValue = {};
  Object.keys(chirpValue).forEach(key => {
    jsonValue[key] = convertChirpValueToJson(chirpValue[key]);
  });
  return jsonValue;
};